// src/components/metaAdmin/tema.js — paleta e fontes da Administração Meta.
//
// Out/26: saiu de dentro do MetaAdminCard quando o painel "Configurar teto"
// (fase 3) passou a usar as mesmas cores — duas cópias divergiriam na
// primeira mudança de tom.
export const C = {
  bg2: '#0E1525', bg3: '#131C30', bg4: '#1A2540',
  border: 'rgba(255,255,255,0.07)', border2: 'rgba(255,255,255,0.12)',
  green: '#00D67C', greenHover: '#00f090', greenDim: 'rgba(0,214,124,0.10)',
  greenGlow: 'rgba(0,214,124,0.22)', greenBdr: 'rgba(0,214,124,0.28)',
  red: '#FF4560', redDim: 'rgba(255,69,96,0.12)', redBdr: 'rgba(255,69,96,0.34)',
  amber: '#FFAA00', amberDim: 'rgba(255,170,0,0.12)', amberBdr: 'rgba(255,170,0,0.2)',
  blue: '#5BA4F5', blueDim: 'rgba(91,164,245,0.10)',
  text: '#DDE4F0', text2: '#7A8799', text3: '#3E4D60',
};
export const FONT_TXT = "'Syne', sans-serif";
export const FONT_NUM = "'Outfit', sans-serif";
